import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const useEmulator = process.env.REACT_APP_USE_EMULATOR === 'true';

let app = null;
let db = null;
let auth = null;

try {
  if (!process.env.REACT_APP_FIREBASE_API_KEY || process.env.REACT_APP_FIREBASE_API_KEY === 'your-api-key') {
    throw new Error('Firebase API key not properly configured');
  }
  
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  auth = getAuth(app);

   // Connect to emulators if useEmulator is true
   if (useEmulator) {
    connectFirestoreEmulator(db, 'localhost', 8080); // Default Firestore emulator port
    connectAuthEmulator(auth, 'http://localhost:9099'); // Default Auth emulator port
    console.log('Connected to Firebase emulators (local mode)');
  } else {
    console.log('Connected to Firebase remote server');
  }

  console.log('Firebase initialized successfully');
} catch (error) {
  console.error('Error initializing Firebase:', error);
  console.log('Firebase will not be available - using dummy data instead');
}

export { db, auth };
